<template>
  <div
    v-for="(option, index) in options"
    :key="'item-' + index"
    tabindex="-1"
    name="dropdown-item"
    class="flex cursor-pointer justify-between px-4 py-2 text-base text-black md:m-0 md:items-center md:justify-between md:hover:bg-primary/10"
    @click="$emit('click', option)"
  >
    <slot name="optionItem" :option="option">
      <div :class="{ 'font-bold': activeOption?.value == option.value }">
        {{ option.label }}
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

import { OptionType } from './ui.types';

defineEmits(['click']);

withDefaults(
  defineProps<{
    options: OptionType[];
    activeOption: OptionType | null;
  }>(),
  { options: () => [] }
);

onMounted(() =>
  document
    .querySelector<HTMLDivElement>('[name="dropdown-item"].active')
    ?.focus()
);
</script>
